import React from 'react';
import { useWizard } from './WizardContext';

export default function WizardButtons() {
  const { isFirst, isLast, goBack, goNext, nextDisabled } = useWizard();

  return (
    <div className="sticky bottom-0 z-10 bg-white border-t border-cs-gray-100 flex justify-between items-center w-full p-4 mt-auto rounded-b-lg">
      <div>
        {!isFirst && (
          <button
            className="btn btn-tertiary disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={goBack}
          >
            Back
          </button>
        )}
      </div>
      <div>
        {!isLast && (
          <button
            className="btn btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={nextDisabled}
            onClick={goNext}
          >
            Next
          </button>
        )}
        {isLast && (
          <button
            className="btn btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={nextDisabled}
            onClick={goNext}
          >
            Finish
          </button>
        )}
      </div>
    </div>
  );
}
